import styled from 'styled-components';
import { Column, DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';
import { EllipsisWithLineClamp } from '@simplywallst/ui-core';

export const BriefModalContent = styled('div')`
  margin-top: -${({ theme }) => theme.x1spacePx}px;
  color: ${({ theme }) => theme.color.spaceGray};
  h2 {
    ${({ theme }) => theme.typography.largeStrong}
    margin: 0;
    margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  }
  span {
    ${({ theme }) => theme.typography.small}
  }
  ul {
    margin-top: ${({ theme }) => theme.x3spacePx}px;
    padding-left: 18px;
    li {
      list-style-type: disc;
      margin-bottom: 12px;
    }
    ul {
      margin-top: auto;
      li {
        list-style-type: circle;
        margin-bottom: 12px;
      }
    }
  }
`;

export const BriefModalTitle = styled('h1')`
  ${EllipsisWithLineClamp(1)}
  padding-right: ${({ theme }) => theme.x4spacePx}px;
`;

export const StyledColumn = styled(Column)`
  ${media.smDown`
    height: 100%;
  `}
`;

export const StyledGrid = styled(Grid)`
  width: 100%;
`;
